import { handleLinkClick } from "@/shared/utils";
import { useState } from "@/store/vuex-composition-mappers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("useGoToLink");

export function useGoToLink(target = "_blank") {
    const { preview } = useState("shared/view", ["preview"]);

    return {
        goToLink(url) {
            logger.debug("goToLink", preview.value, url);
            handleLinkClick(url, preview.value, target);
        },
    };
}
